module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.sharer.organisation.name) + " - "), _c('b', [_c('small', [_vm._v(_vm._s(_vm.sharer.telcoSiteId))])])]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "sharer-equipment",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" Equiment")]), _vm._v(" "), _c('equip-table', {
    attrs: {
      "no-add": _vm.isTelco() || !_vm.isManager(),
      "site-id": _vm.sharer.site_id,
      "owner-id": _vm.sharer.organisation_id,
      "site-data": _vm.siteData,
      "showSearch": false,
      "title": (_vm.sharer.organisation.shortName ? _vm.sharer.organisation.shortName : _vm.sharer.organisation.name) + ' Equipment'
    }
  })], 1), _vm._v(" "), (_vm.canAccess('finance|project')) ? _c('el-tab-pane', {
    attrs: {
      "name": "sharer-project",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Project")]), _vm._v(" "), _c('project-tab', {
    attrs: {
      "sharer": _vm.sharer,
      "site-data": _vm.siteData,
      "read-only": _vm.readOnly
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance|project')) ? _c('el-tab-pane', {
    attrs: {
      "name": "sharer-utility",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" " + _vm._s(_vm.utilLabel) + " Supply")]), _vm._v(" "), _c('utility-tab', {
    attrs: {
      "sharer": _vm.sharer,
      "site-data": _vm.siteData,
      "read-only": _vm.readOnly
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance|project')) ? _c('el-tab-pane', {
    attrs: {
      "name": "sharer-backhaul",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" Backhaul")]), _vm._v(" "), _c('backhaul-tab', {
    attrs: {
      "site-id": _vm.sharer.site_id,
      "site-data": _vm.siteData,
      "sharer-id": _vm.sharer.organisation_id,
      "read-only": _vm.readOnly
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.canAccess('finance|admin|management') && _vm.sharer.site_id && _vm.sharer.id) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('files-panel', {
    attrs: {
      "title": "Sharer Docs",
      "type": "site",
      "id": _vm.sharer.site_id,
      "process": "sharer",
      "process-id": _vm.sharer.id
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sharer.updated_at) ? _c('div', [_c('hr'), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.sharer.updated_at)))]), (_vm.sharer.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.sharer.updated_by))]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57874a9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/sharers/LicenseeDetails.vue
// module id = 1576
// module chunks = 0